/* eslint-disable react/jsx-no-bind */
import { useNavigate, useSearchParams, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { StepsDisplayMode, useBuildPreferencesStore } from "../../lib/useBuildPreferencesStore";
import FilterByDropdown from "../../components/Sidebar/FilterByDropdown";
import { useMobileBreakpoint } from "../../lib/useBreakpoints";
import { MobileStepsView } from "../../components/MobileStepsView";
import { SubNavLink } from "../../components/SubNavLink";
import classNames from "classnames";
import { applySearchParams } from "../../lib/urlForView";
import useQueryParams from "../../lib/useQueryParams";

export function StepsIndexRedirect() {
  const currentModeId = useBuildPreferencesStore((state) => state.stepsDisplayMode);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    let display: StepsDisplayMode;

    switch (currentModeId) {
      case StepsDisplayMode.Canvas:
      case StepsDisplayMode.Waterfall:
      case StepsDisplayMode.Table:
        display = currentModeId;
        break;
      default:
        // Fallback to canvas if unknown or not set
        display = StepsDisplayMode.Canvas;
    }

    navigate(
      { pathname: `./${display}`, search: searchParams.toString() },
      { replace: true, flushSync: true },
    );
  }, [currentModeId]);

  return null;
}

const displayModes = [
  { id: StepsDisplayMode.Canvas, label: "Canvas" },
  { id: StepsDisplayMode.Table, label: "Table" },
  {
    id: StepsDisplayMode.Waterfall,
    label: "Waterfall",
  },
];

export default function StepsPage() {
  const params = useQueryParams();
  const isMobile = useMobileBreakpoint();
  const setStepsDisplayMode = useBuildPreferencesStore((state) => state.setStepsDisplayMode);

  return (
    <div className="flex-auto min-w-0 flex flex-col">
      <div
        className={classNames(
          "flex gap-3 px-2.5 pb-1.5 pt-2 border-b border-b-gray-400 shadow-sm z-20",
          {
            "bg-slate-100": Features.BetterBuildsUIGA,
            "bg-white": !Features.BetterBuildsUIGA,
          },
        )}
      >
        <div className="hidden md:!flex gap-2">
          {displayModes.map((mode) => (
            <SubNavLink
              to={applySearchParams(`./${mode.id}`, params)}
              key={mode.id}
              onClick={() => setStepsDisplayMode(mode.id)}
            >
              {mode.label}
            </SubNavLink>
          ))}
        </div>

        <FilterByDropdown />
      </div>

      {isMobile ? (
        <div className="mt-1 flex-auto bg-white rounded-b-md">
          <MobileStepsView />
        </div>
      ) : (
        <Outlet />
      )}
    </div>
  );
}
